import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

// Pages
import HomePage from "@/pages/HomePage";
import SimulateurPage from "@/pages/SimulateurPage";
import ServicesPage from "@/pages/ServicesPage";
import FeedbacksPage from "@/pages/FeedbacksPage";
import RendezVousPage from "@/pages/RendezVousPage";
import AProposPage from "@/pages/AProposPage";
import BlogPage from "@/pages/BlogPage";
import BlogArticlePage from "@/pages/BlogArticlePage";
import ContactPage from "@/pages/ContactPage";
import AdminPage from "@/pages/AdminPage";
import ConnectPage from "@/pages/ConnectPage";

// Layout
import Layout from "@/components/Layout";

function App() {
  return (
    <div className="min-h-screen bg-slate-50">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/simulateur" element={<SimulateurPage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/feedbacks" element={<FeedbacksPage />} />
            <Route path="/rendez-vous" element={<RendezVousPage />} />
            <Route path="/a-propos" element={<AProposPage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:slug" element={<BlogArticlePage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/connect" element={<ConnectPage />} />
          </Route>
          <Route path="/admin/*" element={<AdminPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
